/* //////////////////////////////////////////////////////////////////////////
                                  J Q U E R Y
   ////////////////////////////////////////////////////////////////////////// */

jQuery(document).ready(function($) {
	
/* ==========================================================================
   Input Placeholder
   ========================================================================== */

$('input[placeholder]').simplePlaceholder();


}); // End jQuery
